
import { Mail } from "lucide-react";
import { Link } from "react-router-dom";
import { VersionInfo } from "@/components/common/VersionInfo";
import { ActionLinks } from "@/components/tools/ActionLinks";
import { useLocation } from "react-router-dom";

export const Footer = () => {
  const location = useLocation();
  const isWelcomePage = location.pathname === "/welcome";
  
  return (
    <footer className="mt-20">
      {/* Message Beta Publique */}
      <div className="w-full bg-blue-50 py-3 text-center">
        <p className="font-medium text-blue-800">Beta Publique</p>
      </div>
      
      {/* ActionLinks affiché partout sauf sur la page welcome */}
      {!isWelcomePage && (
        <div className="w-full bg-gray-50 py-2">
          <div className="w-full max-w-[1500px] mx-auto px-2">
            <ActionLinks />
          </div>
        </div>
      )}
      
      <div className="border-t border-gray-100">
        <div className="max-w-7xl mx-auto py-8 px-4">
          <div className="text-center">
            <div className="flex items-center justify-center gap-2 mb-2">
              <img 
                src="/lovable-uploads/eedf0427-9b29-40a6-8875-95bd3aaac1d6.png" 
                alt="Drapeau français" 
                className="h-4 w-auto"
              />
              <p className="text-sm">AlunaTools est une solution conçue, développée et hébergée en France.</p>
              <a 
                href="https://alunatools.fr/solution-marketing-francaise-securisee" 
                className="text-sm text-[#EFB036] hover:underline"
                target="_blank"
                rel="noopener noreferrer"
              >
                En savoir plus
              </a>
            </div>
            
            <div className="flex items-center justify-center gap-2 mb-2">
              <Mail className="h-4 w-4 text-[#EFB036]" />
              <a href="mailto:contact@alunatools.fr" className="text-sm hover:text-[#EFB036] transition-colors">
                Signaler un bug
              </a>
            </div>
            
            <div className="flex justify-center">
              <VersionInfo />
            </div>
          </div>

          <div className="mt-4 pt-4 border-t border-gray-50 text-center text-xs text-gray-500">
            <p>© {new Date().getFullYear()} AlunaTools. Tous droits réservés.</p>
          </div>
        </div>
      </div>
    </footer>
  );
};
